module.exports = __webpack_public_path__ + "static/img/sessao-expirada.1a896903.svg";